import {ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, ViewChild, ViewRef} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {SwitchBoard} from "../../services/SwitchBoard";
import {TpFirmTodoService} from "../../tpiq-services/tp-firm-todo.service";
import {TasksService} from "../../services/Tasks.service";
import {LoadingService} from "../../services/LoadingService";
import {TaxPlanningService} from "../../tpiq-services/tax-planning.service";
import {takeUntil} from "rxjs/operators";
import {ToastService} from "../../services/Toast.service";
import {StateService} from "../../services/StateService";
import {Router} from "@angular/router";
import {TOAST_TYPE} from "../../constants/Tpiq.constants";
import {State} from "../../models/State";
import {PageTitleService} from "../../services/PageTitle";
import {Session} from "../../services/Session";
import {v4 as uuid} from 'uuid';
import {TrackerPaginatedTableComponent} from "../../tables/tracker-paginated-table/tracker-paginated-table.component";
import {TpiqSelectDropdownComponent} from "../../input-search/tpiq-select-dropdown/tpiq-select-dropdown.component";
import {NgMultiSelectDropDownModule} from "ng-multiselect-dropdown";
import {TpiqCustomDatepicker} from "../../directives/tpiq-custom-datepicker";
import {FroalaEditorModule, FroalaViewModule} from "angular-froala-wysiwyg";
import { environment } from '../../../environments/environment';

declare var _: any;
declare let jQuery: any;

@Component({
  selector: 'app-todos',
  standalone: true,
  imports: [CommonModule, FormsModule, TrackerPaginatedTableComponent, TpiqSelectDropdownComponent, NgMultiSelectDropDownModule,
  TpiqCustomDatepicker,FroalaEditorModule,FroalaViewModule],
  templateUrl: './todos.component.html',
  styleUrl: './todos.component.scss'
})
export class TodosComponent implements OnInit, OnDestroy {
  org: string;
  userId: string;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  routeSub: any;
  hasData = false;
  tableData: any = {};
  isLoading = false;
  hasNextSet = false;
  nextIndex = 0;
  todoSort: any = {};
  todoRows: Array<any> = [];
  view = 'Assigned';
  todoTableColumns: Array<any> = [];
  chunkStatus: Array<any> = [];
  boxColors = ['#475E79', '#0AA8E2', '#3474e3', '#DFCF6A'];
  todoStatuses: Array<any> = [];
  countData: any = {};
  hasCountData = false;
  priorities: Array<any> = [{id: 'High', name: 'High', badge: 'H', colorCode: '#f1645a'},
    {id: 'Medium', name: 'Medium', badge: 'M', colorCode: '#0AA8E2'}, {id: 'Low', name: 'Low', badge: 'L', colorCode: '#0AA8E2'}];
  allClientsList: Array<any> = [];
  selectedClients = [];
  selectedClient = [];
  clientdropdownSettings = {
    singleSelection: false,
    idField: 'clientId',
    textField: 'clientName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true,
  };
  filterObj: any = {
    clientIds: [],
  };
  dataObj = {};
  selectedTableRows: Array<any> = [];
  actions: Array<any> = [];
  flagValue = '';
  flagName = '';
  @ViewChild('firmTodosTable') firmTodosTable;
  bulkSelectAll = false;
  bulkSelectCount: any;
  bulkUnselected: Array<any> = [];
  reveal: any = {
    flag: false,
    todoCreation: false
  };
  bulkDueDate: any;
  bulkPriorityId: any;
  users: Array<any> = [];
  clientPlans: any;
  planStrategies: any;
  todoData = {
    titile: '',
    dueDate: '',
    priority: '',
    description: ''
  };
  todoDescriptionEditorOptions: any = {
    heightMin: 100,
    heightMax: 120,
    toolbarButtons: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'color', 'insertLink', 'outdent', 'indent', 'lineHeight'],
    toolbarSticky: true,
    toolbarVisibleWithoutSelection: false,
    toolbarInline: true,
    fontFamilySelection: true,
    placeholderText: 'Write your description here...',
    charCounterCount: false,
    colorsText: ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'],
    events: {},
    key: environment.froalaKey,
    pasteDeniedAttrs: ['class', 'id', 'style'],
    imageUploadRemoteUrls: false,
  };
  selectedPlanStrategy: any;
  selectedPlan: any;
  selectedClientForTodoCreation: any;

  constructor(private titleService: PageTitleService, private stateService: StateService, private _router: Router,
              private loadingService: LoadingService, private switchBoard: SwitchBoard, private toastService: ToastService,
              private changeDetectorRef: ChangeDetectorRef, private todoService: TpFirmTodoService,
              private taxPlanningService: TaxPlanningService, private tasksService: TasksService) {
  }

  ngOnInit() {
    this._init();
  }

  _init() {
    this.org = Session.getOrg();
    this.userId = Session.getUser().id;
    this.users = Session.getUsers() || [];
    if (this.users && this.users.length == 0) {
      this.getDefaultCompanyUsers();
    } else {
      this.formatUsersData();
    }
    const prevState = this.stateService.getPrevState();
    if (prevState && prevState.key === 'firm-todos') {
      const data = prevState.data;
      this.view = data.view ? data.view : 'Assigned';
      this.setPageTitle();
      this.stateService.pop();
      this.loadingService.triggerLoadingEvent(true);
      this.getAllClientsList(false, data);
    } else {
      this.switchBoard.onClearSearch.next({});
      this.setPageTitle();
      this.getAllClientsList(true, {});
    }
    this.updateActions();

    this.switchBoard.onPageChangeListener.next({});

    this.switchBoard.onToggleFeedback.next({
      display: true,
      pageName: 'Todos page'
    });

    this.switchBoard.onToastConfirm.pipe(takeUntil(this.destroy$))
      .subscribe(toast => {
        this.deleteTodo(toast.data);
      });

    this.switchBoard.onClickPrev
      .pipe(takeUntil(this.destroy$)).subscribe(title => {
      this.gotoDefaultPage();
    });
  }

  gotoDefaultPage() {
    const prevState = this.stateService.getPrevState();
    if (prevState) {
      this.stateService.pop();
      this._router.navigate([prevState.url]);
    }
  }

  formatUsersData() {
    if (this.users && this.users.length > 0){
      _.each(this.users, function(user){
        user['name'] = user.firstName + ' ' + user.lastName;
        user['email'] = user.id;
      });
    }
  }

  getDefaultCompanyUsers() {
    this.tasksService.getAssignees().subscribe(response => {
      this.users = response.users;
      _.forEach(this.users, function(user) {
        user.name = user.firstName + ' ' + user.lastName;
        user.email = user.id;
      });
      Session.setUsers(this.users);
    }, error => {
    });
  }

  setPageTitle() {
    this.titleService.setPageTitle(`Todo's / ${this.view}`);
  }

  toggle(view) {
    this.loadingService.triggerLoadingEvent(true);
    this.view = view;
    this.setPageTitle();
    this.updateActions();
    this.resetSelectedCheckBoxes();
    this.nextIndex = 0;
    this.tableData.rows = [];
    this.todoRows = [];
    this.todoSort = {};
    this.fetchNextSet(true);
  }

  fetchNextSet(refresh) {
    const request = this.setRequestObj();
    Object.assign(request, this.filterObj);
    if (!_.isEmpty(request)) {
      this.getData(request, refresh);
    }
  }

  setRequestObj() {
    let request: any = {};
    if (this.nextIndex === 0 || this.hasNextSet) {
      const sortObj = this.todoSort;
      request = this.getSortingObject(sortObj);
      request.fromIndex = this.nextIndex;
    }
    return request;
  }

  getData(data, refresh) {
    this.loadingService.triggerLoadingEvent(true);
    this.dataObj = {...data};
    if (refresh) {
      this.getCountData(data);
    }
    data.status = this.view;
    this.todoService.getFirmTodosTableData(this.org, this.userId, data).subscribe(response => {
      this.isLoading = false;
      this.todoTableColumns = response.columns;
      this.todoRows = [...this.todoRows, ...response.toDosList];
      if (this.todoRows.length > 0) {
        this.todoRows = _.uniqBy(this.todoRows, 'id');
      }
      this.buildTodosTableData(response.toDosList, refresh);
      this.nextIndex += response.toDosList.length;
      this.hasNextSet = response.hasNextPage;
    }, error => {
      this.isLoading = false;
      this.loadingService.triggerLoadingEvent(false);
    });
  }

  getCountData(data) {
    this.todoService.getFirmTodosCount(this.org, this.userId, data)
      .subscribe( response => {
        if (response.count && response.count.length > 0 ) {
          this.setBoxesCount(response.count);
        }
      }, error => {
      });
  }

  buildTodosTableData(data, refreshTable?) {
    const base = this;
    this.tableData.options = {
      height: '77vh',
      selectorString: 'id',
      showSearch: false,
    };

    this.tableData.columns = [];
    this.tableData.columns = this.formatColumnsForTable(this.todoTableColumns);
    this.tableData.columns.push({name: 'actions', title: '', type: 'html', classes: 'actions-class', sortable: false});

    if (refreshTable) {
      this.tableData.rows = [];
    } else {
      this.tableData.rows = this.tableData.rows || [];
    }
    const rows = base.tableData.rows || [];

    data.forEach(function(item){
      const row = base.createTableRow(item);
      rows.push(row);
    });

    this.tableData = {...this.tableData, rows};
    this.handleSortOrder(this.todoSort, this.tableData.columns);

    if (refreshTable) {
      this.hasData = false;
    }
    setTimeout(() => {
      base.isLoading = false;
      base.hasData = true;
      base.loadingService.triggerLoadingEvent(false);
    });
    setTimeout(() => {
      if (base.bulkSelectAll) {
        jQuery('input.global-checkbox').prop( 'checked', true);
        base.handleRowSelect(base.tableData.rows, true);
      }
    }, 1000);
  }

  formatColumnsForTable(data) {
    const base = this;
    const colsArray = [];
    let orderArray;
    if (typeof data !== 'string') {
      orderArray = data;
    } else {
      orderArray = JSON.parse(data);
    }
    // colsArray.push({name: 'selectCol', title: `<input type='checkbox' class='global-checkbox'/>`, type: 'html', sortable: false});
    _.each(Object.keys(orderArray), function(key) {
      if (key === 'Client') {
        colsArray.push({
          name: orderArray[key], title: key, type: 'html', classes: 'pointer', sortable: true});
      } else if (key === 'Due Date') {
        colsArray.push({
          name: orderArray[key], title: key, type: 'date', format: 'MM/DD/YYYY', placeholder: 'MM/DD/YYYY',
          classes: 'input-date pointer', sortable: true});
      } else if (key === 'Priority') {
        colsArray.push({
          name: orderArray[key], title: key, type: 'badge-input-search', displayName: 'badge', full_name: 'name',
          background: 'colorCode', 'multi-dropdown': false, data: base.priorities, placeholder: key,
          classes: 'input-search pointer', sortable: true});
      } else if (key === 'Description') {
        colsArray.push({
          name: orderArray[key], title: key, type: 'html', classes: 'pointer ', sortable: true});
      }  else if(key != 'Assignees'){
        colsArray.push({name: orderArray[key], title: key, type: 'normal', classes: 'pointer', sortable: false});
      }
    });
    return colsArray;
  }

  createTableRow(item) {
    const base = this;
    const row: any = {};
    // row.selectCol = `<input type='checkbox' class='checkbox'/>`;
    _.each(item, function(value, key){
      if (key === 'clientName') {
        row.client_name = item[key];
        row[key] = `<a class='actionOnId' data-action='edit'><span class='icon pointer'>${base.setStringSizeLimit(item[key])}</span></a>`;
      } else if (key === 'priority') {
        row[key] =  base.getPriorityBadge(item[key]);
      } else if (key === 'description') {
        row[key] = `<span class='icon pointer'>${base.setStringSizeLimit(item[key].replace(/<[^>]+>/g, ''))}</span>`;
        // row[key] = `<span class='icon badge-tooltip pointer'>${base.setStringSizeLimit(item[key].replace(/<[^>]+>/g, ''))}<span class='bottomTooltiptext table-data-tooltip' style="left: -20% !important;">${base.setTooltipStringLimit(item[key].replace(/<[^>]+>/g, ''))}</span></span>`;
      } else {
        row[key] = item[key];
      }
    });

    let deleteTodo = '';
    let moveStatus = '';
    let postString = '';

    deleteTodo = `<a class='action' data-action='delete-todo'><span class='todo-del'><i class='material-icons delete'>delete</i></span></a>`;
    postString = `<a class='action' data-action='todo-single' style='margin:0px 0px 0px 5px'><span class='comment-badge'><div class='material-icons mdl-badge tracker-badge last-activity' style='color: rgb(128, 128, 128)' data-badge=''>comment</div></span></a>`;
    if (item.postlastActivity) {
      postString = `<a class='action' data-action='todo-single' style='margin:0px 0px 0px 5px'><span class='comment-badge'><div class='material-icons tracker-badge' style='color: rgb(128, 128, 128)' data-badge=''>comment</div></span></a>`;
    }
    if (this.view === 'Assigned') {
      moveStatus = `<a class='action' data-action='move_to_done'><span class='next-status'><i class='material-icons'>done</i></span></a>`;
    } else if (this.view === 'Done') {
      moveStatus = `<a class='action' data-action='move_to_assigned'><span class='status_move_done'><i class='material-icons'>done</i></span></a>`;
    }

    row.actions = moveStatus + postString + deleteTodo;
    row.isEditable = false;
    return row;
  }

  getPriorityBadge(priority) {
    if (priority) {
      return _.find(this.priorities, {name: priority});
    }
    return false;
  }

  setStringSizeLimit(name) {
    if (name && name.length > 20) {
      return name.substring(0, 20) + '....';
    } else {
      return name;
    }
  }

  setTooltipStringLimit(name) {
    if (name && name.length > 150) {
      return name.substring(0, 150) + '....';
    } else {
      return name;
    }
  }

  handleSortOrder(sortOrder, columns){
    _.each(columns, function(column){
      column.sortType = sortOrder[column.name];
    });
  }

  getSortingObject(sortObject) {
    for (const key in sortObject) {
      if (sortObject.hasOwnProperty(key) && sortObject[key]) {
        return {
          sortKey: key,
          sortOrder: sortObject[key],
        };
      }
    }
    return {};
  }

  setBoxesCount(response) {
    this.countData = response;
    this.formBoxesColors();
    this.todoStatuses = _.cloneDeep(response);
    this.todoStatuses.shift();
    if (this.countData.length === 12) {
      const firstChunk = this.countData.slice(0, 3);
      const statuses = this.countData.slice(3, this.countData.length);
      this.chunkStatus = _.chunk(statuses, 3);
      this.chunkStatus.unshift(firstChunk);
    } else if (this.countData.length === 11) {
      const firstChunk = this.countData.slice(0, 2);
      const statuses = this.countData.slice(2, this.countData.length);
      this.chunkStatus = _.chunk(statuses, 3);
      this.chunkStatus.unshift(firstChunk);
    } else if (this.countData.length === 10) {
      const firstChunk = this.countData.slice(0, 2);
      const statuses = this.countData.slice(2, this.countData.length);
      this.chunkStatus = _.chunk(statuses, 3);
      this.chunkStatus.unshift(firstChunk);
    } else if (this.countData.length === 9) {
      const firstChunk = this.countData.slice(0, 2);
      const statuses = this.countData.slice(2, this.countData.length);
      this.chunkStatus = _.chunk(statuses, 3);
      this.chunkStatus.unshift(firstChunk);
    } else if (this.countData.length === 8) {
      const firstChunk = this.countData.slice(0, 2);
      const secondChunk = this.countData.slice(2, 5);
      const statuses = this.countData.slice(5, this.countData.length);
      this.chunkStatus = _.chunk(statuses, 2);
      this.chunkStatus.unshift(secondChunk);
      this.chunkStatus.unshift(firstChunk);
    } else if (this.countData.length === 7) {
      const firstChunk = this.countData.slice(0, 2);
      const secondChunk = this.countData.slice(2, 5);
      const statuses = this.countData.slice(5, this.countData.length);
      this.chunkStatus = _.chunk(statuses, 1);
      this.chunkStatus.unshift(secondChunk);
      this.chunkStatus.unshift(firstChunk);
    } else if (this.countData.length === 6) {
      this.chunkStatus = _.chunk(this.countData, 2);
    } else {
      this.chunkStatus = _.chunk(this.countData, 1);
    }
    this.hasCountData = true;
  }

  formBoxesColors() {
    const base = this;
    for (const i in base.countData) {
      if (this.countData[i]) {
        this.countData[i].colorCode = this.boxColors[i];
      }
    }
  }

  handleScroll($event) {
    const base = this;
    if ($event.isReachingBottom && !base.isLoading && !$event.isWindowEvent && this.hasNextSet) {
      base.isLoading = true;
      this.fetchNextSet(false);
    }
  }

  handleAction($event) {
    const action = $event.action;
    this.resetSelectedCheckBoxes();
    if (action === 'edit') {
      // this.navigateToTodo($event);
      this.navigateToTodoSinglePage($event);
    } else if (action === 'todo-single') {
      this.navigateToTodoSinglePage($event);
    } else if (action === 'delete-todo') {
      this.removeTodo($event);
    } else if (action === 'move_to_done') {
      this.changeStatus($event, 'Done');
    } else if (action === 'move_to_assigned') {
      this.changeStatus($event, 'Assigned');
    }
  }

  navigateToTodo(data) {
    this.addFirmTodoState();
    this.titleService.setPageTitle(`Edit Todo / ${data.client_name}`);
    const link = ['clients', data.clientId, 'firmTodos', 'todos', data.id];
    this._router.navigate(link);
  }

  navigateToTodoSinglePage(data) {
    this.addFirmTodoState();
    const link = ['clients', data.clientId, data.client_name, 'toDo', data.id, 'singlepage'];
    this._router.navigate(link);
  }

  addFirmTodoState() {
    const data = {
      view: this.view,
      sort: this.todoSort,
      clients: this.selectedClients,
      selectedClients: this.selectedClient,
      selectedClientFilterObj: this.filterObj.clientIds,
    };
    this.stateService.addState(new State('firm-todos', this._router.url, data, null));
  }

  removeTodo($event) {
    this.toastService.pop(TOAST_TYPE.confirm, 'Are you sure you want to delete?', $event);
  }

  deleteTodo(data) {
    const base = this;
    this.loadingService.triggerLoadingEvent(true);
    this.todoService.removeToDo(this.org, this.userId, data.clientId, data.id)
      .subscribe(response => {
        if (this.tableData.rows.length <= 10) {
          this.resetTabData();
        } else {
          this.getCountData(this.dataObj);
          _.remove(this.todoRows, {id: data.id});
          const index = _.findIndex(this.tableData.rows, {id: data.id});
          if (index !== -1) {
            this.tableData.rows.splice(index, 1);
            const rows = this.tableData.rows || [];
            this.tableData = {...this.tableData, rows};
          }
          this.loadingService.triggerLoadingEvent(false);
        }
        this.toastService.pop(TOAST_TYPE.success, 'ToDo Deleted Successfully');
      }, error => {
        error = JSON.parse(error);
        const message = error.message || 'Failed To Delete ToDo';
        this.toastService.pop(TOAST_TYPE.error, message);
        this.loadingService.triggerLoadingEvent(false);
      });
  }

  changeStatus($event, status) {
    const base = this;
    const data = _.find(this.todoRows, {id: $event.id});
    // data.checked = true;
    let obj = {};
    obj['id'] = data.id;
    obj['action'] = 'singleUpdate';
    obj['actedOn'] = 'status';
    obj['value'] = status;
    obj['ids'] = [];

    this.loadingService.triggerLoadingEvent(true);
    this.todoService.updateFirmTodoStatus(this.org, this.userId, obj)
      .subscribe(response => {
        if (this.tableData.rows.length <= 10) {
          this.resetTabData();
        } else {
          this.getCountData(this.dataObj);
          _.remove(this.todoRows, {id: $event.id});
          const index = _.findIndex(this.tableData.rows, {id: $event.id});
          if (index !== -1) {
            this.tableData.rows.splice(index, 1);
            const rows = this.tableData.rows || [];
            this.tableData = {...this.tableData, rows};
          }
          this.loadingService.triggerLoadingEvent(false);
        }
        if (status === 'Done') {
          this.toastService.pop(TOAST_TYPE.success, 'Todo Marked as Done');
        } else if (status === 'Assigned') {
          this.toastService.pop(TOAST_TYPE.success, 'Todo Moved to Assigned');
        }
      }, error => {
        this.toastService.pop(TOAST_TYPE.error, 'Failed To Perform action');
        this.loadingService.triggerLoadingEvent(false);
      });
  }

  resetTabData() {
    this.loadingService.triggerLoadingEvent(true);
    this.resetSelectedCheckBoxes();
    this.nextIndex = 0;
    this.tableData.rows = [];
    this.fetchNextSet(true);
  }

  sortByColumn(obj) {
    this.todoSort[obj.column] = obj.order;
    this.resetSortOrder(this.todoSort, this.tableData.columns, obj.column);
    this.nextIndex = 0;
    this.resetSelectedCheckBoxes();
    this.fetchNextSet(true);
  }

  resetSortOrder(sortOrder, columns, column) {
    _.each(columns, function(col){
      if (col.name !== column) {
        sortOrder[col.name] = '';
      }
    });
  }

  getAllClientsList(refresh, prevData) {
    const data = {fromIndex : -1};
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getClients(this.org, this.userId, data).subscribe(response => {
      this.setClientsList(response.clients, refresh, prevData);
    }, error => {
      this.loadingService.triggerLoadingEvent(false);
      this.toastService.pop(TOAST_TYPE.error, 'Failed to get clients list');
    });
  }

  setClientsList(clients, refresh, prevData) {
    const base = this;
    let obj = [];
    _.forEach(clients, function(company) {
      company['clientId'] = company.qountClientId;
      company['clientName'] = company.firstName + ' ' + company.lastName;
      // company['companyType'] = key;
    });
    obj = _.concat(obj, clients);
    this.allClientsList = obj;
    if (refresh) {
      this.fetchNextSet(true);
    } else {
      if (!_.isEmpty(prevData)) {
        base.filterObj.clientIds = prevData.selectedClientFilterObj ? prevData.selectedClientFilterObj : [];
        base.selectedClients = prevData.clients ? prevData.clients : [];
        base.selectedClient = prevData.selectedClients ? prevData.selectedClients : [];
        base.todoSort = prevData.sort ? prevData.sort : {};
        base.fetchNextSet(true);
      }
    }
  }

  onClientFilterSelect(client: any, check) {
    this.resetSelectedCheckBoxes();
    if (check) {
      this.selectedClient.push(client.clientId);
      this.filterObj.clientIds = this.selectedClient;
    } else {
      this.filterObj.clientIds = _.without(this.selectedClient, client.clientId);
      this.selectedClient = this.filterObj.clientIds;
    }
    this.nextIndex = 0;
    this.fetchNextSet(true);
  }

  onAllClientsFilterSelect(clients: any, check) {
    this.resetSelectedCheckBoxes();
    if (check) {
      this.selectedClient = _.map(clients, 'clientId');
      this.filterObj.clientIds = this.selectedClient;
    } else {
      this.filterObj.clientIds = [];
      this.selectedClient = [];
    }
    this.nextIndex = 0;
    this.fetchNextSet(true);
  }

  updateInput(obj) {
    const todo = _.find(this.todoRows, {id: obj.row.id});
    if (todo) {
      const data = {
        id: obj.row.id,
        action: 'singleUpdate',
        actedOn: 'dueDate',
        value: obj.row.dueDate,
        ids: []
      };
      this.todoService.updateFirmTodoData(this.org, this.userId, data)
        .subscribe( response => {
          const index = _.findIndex(this.tableData.rows, {id: data.id});
          if (index !== -1) {
            const rows = this.tableData.rows || [];
            rows[index].dueDate = obj.row.dueDate;
            this.tableData = {...this.tableData, rows};
            this.todoRows[index].dueDate = obj.row.dueDate;
            this.toastService.pop(TOAST_TYPE.success, 'Due Date Updated Successfully');
          }
        }, error => {
          this.loadingService.triggerLoadingEvent(false);
          this.toastService.pop(TOAST_TYPE.error, 'Failed to Update Due Date');
        });
    }
  }

  optionSelected($event) {
    const base = this;
    if ($event.column === 'toDoAssignee') {
      let data = {};
      if ($event.column &&  $event.multiDropdown && $event.type === 'add') {
        data = {
          id: $event.row.id,
          action: 'updateAssignee',
          actedOn: 'assignee',
          value: $event.entry.email,
          ids: []
        };
      } else if ($event.column &&  $event.multiDropdown && $event.type === 'remove') {
        data = {
          id: $event.row.id,
          action: 'removeAssignee',
          actedOn: 'assignee',
          value: $event.entry.email,
          ids: []
        };
      }
      this.todoService.updateFirmTodoData(this.org, this.userId, data)
        .subscribe(response => {
          const index = _.findIndex(this.tableData.rows, {id: $event.row.id});
          if (index !== -1) {
            const rows = this.tableData.rows || [];
            rows[index].toDoAssignee = response.assignees;
            this.tableData = {...this.tableData, rows};
            this.todoRows[index].toDoAssignee = response.assignees;
            this.toastService.pop(TOAST_TYPE.success, 'Assignees Updated Successfully');
          }
        }, error => {
          this.loadingService.triggerLoadingEvent(false);
          this.toastService.pop(TOAST_TYPE.error, 'Failed To Update Assignees');
        });
    } else if ($event.column === 'priority') {
      const todo = _.find(this.todoRows, {id: $event.row.id});
      if (todo) {
        const data = {
          id: $event.row.id,
          action: 'singleUpdate',
          actedOn: 'priority',
          value: $event.entry.id,
          ids: []
        };
        this.todoService.updateFirmTodoData(this.org, this.userId, data)
          .subscribe( response => {
            const index = _.findIndex(this.tableData.rows, {id: data.id});
            if (index !== -1) {
              const rows = this.tableData.rows || [];
              rows[index].priority = base.getPriorityBadge($event.entry.id);
              this.tableData = {...this.tableData, rows};
              this.todoRows[index].priority = $event.entry.id;
              this.toastService.pop(TOAST_TYPE.success, 'Priority Updated Successfully');
            }
          }, error => {
            this.loadingService.triggerLoadingEvent(false);
            this.toastService.pop(TOAST_TYPE.error, 'Failed to Update Priority');
          });
      }
    }
  }

  updateActions() {
    this.actions = [];
    this.actions = [{
      name: 'Due Date',
      value: 'dueDate'
    }, {
      name: 'Priority',
      value: 'priority'
    }, {
      name: 'Delete',
      value: 'delete'
    }];
  }

  resetSelectedCheckBoxes() {
    this.selectedTableRows = [];
    this.updateDashboardTable(false);
    this.flagName = '';
    this.flagValue = '';
    jQuery('input.global-checkbox').prop( 'checked', false);
  }

  handleSelect(event) {
    const base = this;
    if (typeof event === 'boolean') {
      this.selectedTableRows = [];
      this.updateDashboardTable(event);
    } else {
      this.handleRowSelection(event);
    }
  }

  handleRowSelection(obj) {
    const base = this;
    if (obj) {
      const idx = _.findIndex(base.selectedTableRows, {id: obj.id});
      if  (idx === -1) {
        base.selectedTableRows.push(obj);
        if (base.bulkSelectAll) {
          base.bulkSelectCount += 1;
          base.checkAllSelected();
          base.checkforReselect(obj);
        }
      } else {
        base.selectedTableRows.splice(idx, 1);
        if (base.bulkSelectAll) {
          base.bulkUnselected.push(obj);
          jQuery('input.global-checkbox').prop( 'checked', false);
          base.bulkSelectCount -= 1;
        }
        if (base.selectedTableRows.length === 0) {
          base.resetBulkSelected();
        }
      }
    }
  }

  updateDashboardTable(state) {
    if (state) {
      this.bulkSelectAll = true;
      this.getSelectAllCount();
      this.handleRowSelect(this.tableData.rows, state);
    } else {
      this.resetBulkSelected();
      this.handleRowSelect([], state);
    }
  }

  handleRowSelect(selectedRows, state) {
    const base = this;
    if (this.firmTodosTable && this.firmTodosTable.id) {
      const selectedTableId = this.firmTodosTable.id;
      jQuery('#' + selectedTableId).find('tbody tr input.checkbox').each(function(idx, cbox) {
        const id = jQuery(this).closest('tr').attr('id');
        const row = _.find(base.tableData.rows, {id});
        if (!state) {
          jQuery(cbox).prop( 'checked', false );
        } else {
          jQuery(cbox).prop( 'checked', true );
        }
        if (!jQuery(cbox).is(':checked')) {
          _.remove(base.selectedTableRows, {id});
        }
        base.changeDetectorRef.detectChanges();
      });
      _.each(selectedRows, function(doc) {
        base.selectedTableRows.push(doc);
      });
      this.selectedTableRows = _.uniqBy(this.selectedTableRows, 'id');
    }
  }

  getSelectAllCount() {
    const markAllCount = _.find(this.countData, {status: this.view});
    if (markAllCount) {
      this.bulkSelectCount = markAllCount.count;
    }
  }

  checkAllSelected() {
    const markAllCount = _.find(this.countData, {status: this.view});
    if (markAllCount && (markAllCount.count === this.bulkSelectCount)) {
      jQuery('input.global-checkbox').prop( 'checked', true);
    }
  }

  checkforReselect(data) {
    const reselectIndex = _.findIndex(this.bulkUnselected, {id: data.id});
    if (reselectIndex !== -1) {
      this.bulkUnselected.splice(reselectIndex, 1);
    }
  }

  resetBulkSelected() {
    this.bulkSelectAll = false;
    this.bulkSelectCount = '';
    this.bulkUnselected = [];
  }

  onBulkDueDateSelect($event) {
    this.bulkDueDate = $event;
  }

  onBulkPrioritySelect($event) {
    if (!_.isEmpty($event)) {
      this.bulkPriorityId = $event.id;
    } else {
      this.bulkPriorityId = '';
    }
  }

  handleMultipleActions(value, name) {
    this.flagValue = value;
    this.flagName =  name;
    jQuery('#recent-actions').foundation('close');
    if (value === 'dueDate' || value === 'priority' || value === 'delete') {
      this.reveal = {...this.reveal, flag: true};
    } else if (value === 'Done' || value === 'Assigned') {
      this.onBulkApply(value);
    }
  }

  onBulkApply(flagValue) {
    const base = this;
    let obj = {};
    this.loadingService.triggerLoadingEvent(true);
    if (this.validateBulk(flagValue)) {
      if (flagValue === 'dueDate') {
        obj = {
          id: '',
          action: 'bulk',
          actedOn: 'dueDate',
          value: base.bulkDueDate,
          addAll: base.bulkSelectAll,
          ids: base.bulkSelectAll ? [] : _.map(base.selectedTableRows, 'id'),
          ids_to_exclude: base.bulkSelectAll ? _.map(base.bulkUnselected, 'id') : [],
          clientIds: base.bulkSelectAll ? base.filterObj.clientIds : [],
          status: base.view
        };
      } else if (flagValue === 'priority') {
        obj = {
          id: '',
          action: 'bulk',
          actedOn: 'priority',
          value: base.bulkPriorityId,
          addAll: base.bulkSelectAll,
          ids: base.bulkSelectAll ? [] : _.map(base.selectedTableRows, 'id'),
          ids_to_exclude: base.bulkSelectAll ? _.map(base.bulkUnselected, 'id') : [],
          clientIds: base.bulkSelectAll ? base.filterObj.clientIds : [],
          status: base.view
        };
      } else if (flagValue === 'delete') {
        obj = {
          id: '',
          action: 'bulkDelete',
          actedOn: '',
          value: '',
          addAll: base.bulkSelectAll,
          ids: base.bulkSelectAll ? [] : _.map(base.selectedTableRows, 'id'),
          ids_to_exclude: base.bulkSelectAll ? _.map(base.bulkUnselected, 'id') : [],
          clientIds: base.bulkSelectAll ? base.filterObj.clientIds : [],
          status: base.view
        };
      } else if (flagValue === 'Done' || flagValue === 'Assigned') {
        obj = {
          id: '',
          action: 'bulk',
          actedOn: 'status',
          value: flagValue,
          addAll: base.bulkSelectAll,
          ids: base.bulkSelectAll ? [] : _.map(base.selectedTableRows, 'id'),
          ids_to_exclude: base.bulkSelectAll ? _.map(base.bulkUnselected, 'id') : [],
          clientIds: base.bulkSelectAll ? base.filterObj.clientIds : [],
          status: base.view
        };
      }
      this.todoService.updateFirmTodoData(this.org, this.userId, obj)
        .subscribe( response => {
          this.resetSelectedCheckBoxes();
          this.resetTabData();
          if (flagValue === 'dueDate') {
            this.toastService.pop(TOAST_TYPE.success, 'DueDate Updated Successfully');
          } else if (flagValue === 'priority') {
            this.toastService.pop(TOAST_TYPE.success, 'Priority Updated Successfully');
          } else if (flagValue === 'delete') {
            this.toastService.pop(TOAST_TYPE.success, `ToDo's Deleted Successfully`);
          } else if (flagValue === 'Done') {
            this.toastService.pop(TOAST_TYPE.success, `ToDo's Marked as Done`);
          } else if (flagValue === 'Assigned') {
            this.toastService.pop(TOAST_TYPE.success, `ToDo's Moved to Assigned`);
          }
        }, error => {
          this.handleError(error);
        });
      this.hideReveal('flag');
    }
  }

  validateBulk(flagValue) {
    if (flagValue === 'dueDate' && !this.bulkDueDate) {
      this.loadingService.triggerLoadingEvent(false);
      this.toastService.pop(TOAST_TYPE.warning, 'Select Due Date');
      return false;
    } else if (flagValue === 'priority' && !this.bulkPriorityId) {
      this.loadingService.triggerLoadingEvent(false);
      this.toastService.pop(TOAST_TYPE.warning, 'Select Priority');
      return false;
    }
    return true;
  }

  handleError(error) {
    this.loadingService.triggerLoadingEvent(false);
    try {
      error = JSON.parse(error);
      const message = error && error.message ? error.message : 'Failed To perform action';
      this.toastService.pop(TOAST_TYPE.error, message);
    } catch (error) {
      const message = error && error.message ? error.message : 'Failed To perform action';
      this.toastService.pop(TOAST_TYPE.error, message);
    }
  }

  hideReveal(revealFlag) {
    this.reveal[revealFlag] = false;
    if (revealFlag == 'todoCreation') {
      this.resetTodoCreationFields();
    }
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  ngOnDestroy() {
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  openCreateTodoPopup() {
    this.reveal.todoCreation = true;
  }

  onClientSelect(client) {
    this.selectedClientForTodoCreation = client;
    this.getClientPlans(this.selectedClientForTodoCreation.id);
  }

  onClientPlanSelect(plan) {
    this.selectedPlan = plan;
    this.getClientPlanStrategiesInfo(this.selectedPlan.id);
  }

  onPlanStrategySelect(strategy) {
    this.selectedPlanStrategy = strategy;
  }

  getClientPlans(clientId) {
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getPlansForClient(this.org, this.userId, clientId)
      .subscribe((response) => {
        this.loadingService.triggerLoadingEvent(false);
        this.clientPlans = response;
      }, (error) => {
        this.isLoading = false;
        this.loadingService.triggerLoadingEvent(false);
      });
  }

  getClientPlanStrategiesInfo(planId){
    const base = this;
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getTaxPlanStrategiesInfo(this.org, this.userId, planId, 'todo')
      .subscribe({
        next: (response) => {
          this.loadingService.triggerLoadingEvent(false);
          this.planStrategies = response;
        },
        error: (error) => {
          this.toastService.pop(TOAST_TYPE.error, 'Failed to get plan data');
          this.loadingService.triggerLoadingEvent(false);
        }
      });
  }

  setDueDate(date) {
    this.todoData.dueDate = date;
  }

  setPriority($event) {
    const base = this;
    if (!_.isEmpty($event)) {
      this.todoData.priority = $event.id;
    } else {
      this.todoData.priority = 'Medium';
    }
  }

  createTodo() {
    if (this.validateTodoCreation()) {
      const data: any = {
        id: uuid(),
        taskId: this.selectedPlanStrategy.taskId,
        dueDate: this.todoData.dueDate,
        title: this.todoData.titile,
        description: this.todoData.description,
        priority: this.todoData.priority,
        recurring: 'Never'
      };
      data.clientId = this.selectedClientForTodoCreation.clientId;
      // if (this.attachments.length > 0) {
      //   data.documents = this.attachments;
      //   _.forEach(data.documents, function(data) {
      //     delete data.temporaryURL;
      //   });
      // }
      this.loadingService.triggerLoadingEvent(true);
      this.todoService.addSinglePageTodo(this.org, this.userId, this.selectedPlanStrategy.taskId, data)
        .subscribe(response => {
          this.loadingService.triggerLoadingEvent(false);
          this.toastService.pop(TOAST_TYPE.success, 'ToDo created successfully');
          this.hideReveal('todoCreation');
          if(this.view == 'Assigned'){
            this.fetchNextSet(true);
          }
        }, error => {
          this.loadingService.triggerLoadingEvent(false);
          const message = error.message || 'Failed to create ToDo';
          this.toastService.pop(TOAST_TYPE.error, message);
        });
    }
  }

  validateTodoCreation() {
    let isValid = true;
    let todoCreationError = '';
    if (!this.selectedClient) {
      isValid = false;
      todoCreationError = 'Please select a client';
      this.toastService.pop(TOAST_TYPE.error, todoCreationError);
    } else if (!this.selectedPlan) {
      isValid = false;
      todoCreationError = 'Please select a plan';
      this.toastService.pop(TOAST_TYPE.error, todoCreationError);
    } else if (!this.selectedPlanStrategy) {
      isValid = false;
      todoCreationError = 'Please select a strategy';
      this.toastService.pop(TOAST_TYPE.error, todoCreationError);
    } else if (!this.todoData.titile) {
      isValid = false;
      todoCreationError = 'Please enter a title';
      this.toastService.pop(TOAST_TYPE.error, todoCreationError);
    }
    return isValid;
  }

  resetTodoCreationFields() {
    this.selectedClientForTodoCreation = '';
    this.selectedPlan = '';
    this.selectedPlanStrategy = '';
    this.todoData.titile = '';
    this.todoData.priority = '';
    this.todoData.dueDate = '';
    this.todoData.description = '';
  }

}
